// Module
var code = `<template>
  <a class="grid-icon" href.bind="url"> <mdc-icon if.bind="params.data != null" aria-hidden="true">fullscreen</mdc-icon>
  </a>
</template>
`;
// Exports
export default code;